const FormatCell = (accessor: string, formatter: (value: any) => any) => {
  return (props: any) => {
    const field = props[accessor]
    if (!field) {
      return null
    }
    return formatter(field)
  }
}

export default FormatCell
